window.arjoRegionChangeTooltipModule =
  window.arjoRegionChangeTooltipModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const classNamePrefix = 'arjo-o-region-change-tooltip';
    const hideAllTooltipKey = 'hide-all-region-change-tooltip';
    const hideOuterTooltipKey = 'hide-outer-region-change-tooltip';

    const setUp = () => {
      const els = [...document.querySelectorAll(`.${classNamePrefix}`)];
      const isAllTooltipHidden = localStorage.getItem(hideAllTooltipKey);

      const excludeExternalScriptElement = els.filter((el) => !el?.dataset?.externalScript);

      if (isAllTooltipHidden) return;
      excludeExternalScriptElement.forEach((el) => {
        const button = el.querySelector(`.${classNamePrefix}__button .arjo-a-button`);
        el.style.removeProperty('display');
        const isOuterTooltipHidden = localStorage.getItem(hideOuterTooltipKey);
        if (isOuterTooltipHidden && el.classList.contains('outer')) el.style.display = 'none';

        const clickHandler = (e) => {
          e.stopPropagation();
          if (el.classList.contains('desktop') || el.classList.contains('upper') || el.classList.contains('lower')) {
            excludeExternalScriptElement.forEach((element) => {
              element.style.display = 'none';
            });

            localStorage.setItem(hideAllTooltipKey, 'true');
          } else {
            el.style.display = 'none';
            localStorage.setItem(hideOuterTooltipKey, 'true');
          }
        };
        button.addEventListener('click', clickHandler);

        el.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      });
    };

    const init = () => {
      if (state.isInitialized) return;

      setTimeout(setUp, 1000);
      state.isInitialized = true;
    };
    return { init };
  })();

window.addEventListener('load', window.arjoRegionChangeTooltipModule.init);
